import type { PropsWithChildren, ReactNode } from 'react'

import { BulletedListItemStyled } from './styles/BulletedListItemStyled'
import { type IconElement, renderIcon } from '../../../../elements/Icon'
import { Space } from '../../../../elements/Space'

export interface IBulletedListItemProps {
  icon?: IconElement
  iconComponent?: ReactNode
}

export const BulletedListItem = ({
  icon,
  iconComponent,
  children,
}: PropsWithChildren<IBulletedListItemProps>) => {
  return (
    <BulletedListItemStyled showBullet={!icon && !iconComponent}>
      <Space direction='horizontal'>
        {icon ? renderIcon(icon) : iconComponent ? iconComponent : null}
        <>{children}</>
      </Space>
    </BulletedListItemStyled>
  )
}
